import moment from 'moment'
import { COLORS } from '@btime/constants'

export const getSlaStatusColor = slaExpiresAt => {
  if (!slaExpiresAt) return null

  const now = moment()
  const slaDate = moment(slaExpiresAt)

  if (!slaDate.isValid()) return null

  if (now.isAfter(slaDate)) {
    return COLORS.red
  }

  return COLORS.green
}
